import React from 'react';
import clsx from 'clsx';

import Stamp from '@/lib/components/Stamp';
import { useClientTranslation } from '@/lib/i18n/client';
import { SubscribeType } from '@/shared/Subscribe/types';

import { SubscribeForm } from './SubscribeForm';
import styles from './Subscribe.module.scss';

interface SubscribeProps extends SubscribeType {
  vertical?: boolean;
  rotate?: number;
  textStamp: string;
  stampClassName?: string;
  className?: string;
}

export function Subscribe({ vertical = false, textStamp, rotate, className, stampClassName, type = 'footer' }: SubscribeProps) {
  const { t } = useClientTranslation();

  return (
    <div className={clsx(styles.subscribe, className)}>
      <Stamp className={clsx(styles.noSpam, stampClassName)} text={textStamp} rotate={rotate} />
      <div className={styles.subscribeText}>
        <span className="text text-sm text-bold text-mobile-sm">{t('footer.subscribe')}</span>
      </div>
      <SubscribeForm vertical={vertical} type={type} />
    </div>
  );
}
